/**
 * Playable Screens admin tab (library of reusable playable-ad screens: author in the visual editor,
 * review, publish). See routes/admin-playable-screens-tab.tsx and the editor panels.
 */
export const playableTemplates: Record<string, string> = {
  'playable.tab': 'Màn Playable',
  'playable.backToList': 'Quay lại danh sách',
  'playable.loadError': 'Không tải được danh sách màn hình',
  'playable.empty': 'Chưa có màn hình nào. Nhập file HTML hoặc dùng prompt AI để bắt đầu.',
  'playable.col.cover': 'Ảnh bìa',
  'playable.cover.create': 'Tạo ảnh bìa',
  'playable.cover.refresh': 'Vẽ lại ảnh bìa',
  'playable.cover.failed': 'Không vẽ được ảnh bìa (lý do ở console trình duyệt).',
  'playable.cover.skipped': 'Màn vừa được lưu lại; ảnh bìa mới hơn đã có hoặc đang được vẽ.',
  'playable.col.name': 'Tên',
  'playable.col.slug': 'Slug',
  'playable.col.category': 'Danh mục',
  'playable.col.published': 'Đã publish',
  'playable.col.updated': 'Cập nhật',
  'playable.col.actions': 'Hành động',
  'playable.published': 'Đã publish',
  'playable.unpublished': 'Chưa publish',
  'playable.edit': 'Sửa',
  'playable.duplicate': 'Nhân bản',
  'playable.publish': 'Publish',
  'playable.unpublish': 'Gỡ publish',
  'playable.delete': 'Xóa',
  'playable.deleteConfirm': 'Xác nhận?',
  'playable.cancel': 'Hủy',
  'playable.save': 'Lưu',
  'playable.saving': 'Đang lưu…',
  'playable.duplicating': 'Đang nhân bản…',
  'playable.deleting': 'Đang xóa…',
  'playable.publishing': 'Đang publish…',
  'playable.name': 'Tên',
  'playable.slug': 'Slug',
  'playable.category': 'Danh mục',
  'playable.sourceNote': 'Ghi chú nguồn',
  'playable.noCategory': 'Không có danh mục',

  // Playable Builder (công cụ dựng template cho UA — routes/playable-builder-page.tsx)
  'playable.builder.library.title': 'Thư viện màn hình',
  'playable.builder.library.loadError': 'Không tải được danh sách màn hình',
  'playable.builder.library.empty': 'Chưa có màn hình nào được publish.',
  'playable.builder.library.add': 'Thêm vào template',
  'playable.builder.library.variables': '{n} biến',
  'playable.builder.preview.title': 'Xem trước',
  'playable.builder.preview.restart': 'Chạy lại',
  'playable.builder.preview.empty': 'Thêm ít nhất một màn hình để xem trước quảng cáo.',
  'playable.builder.preview.hostFailed': 'Không tải được khung xem trước, thử "Chạy lại".',

  // Trình dựng timeline (routes/playable-builder-timeline.tsx)
  'playable.timeline.title': 'Timeline',
  'playable.timeline.empty': 'Thêm ít nhất một màn hình để xem timeline.',
  'playable.timeline.autoHandleLabel': 'Kéo để chỉnh độ trễ tự động chuyển màn',
  'playable.timeline.animHandleLabel': 'Kéo để chỉnh thời lượng animation',
  'playable.timeline.moveHandleLabel': 'Kéo để đổi thứ tự màn hình',
  'playable.timeline.duplicate': 'Nhân bản màn hình',
  'playable.timeline.remove': 'Xoá màn hình',
  'playable.timeline.removeConfirm': 'Xoá màn “{name}”? Có 8 giây để bấm Hoàn tác nếu xoá nhầm.',
  'playable.timeline.undoToast': 'Đã xoá “{name}”.',
  'playable.timeline.undo': 'Hoàn tác',
  'playable.timeline.add': 'Thêm màn hình',
  'playable.timeline.addBlank': 'Màn hình trắng',
  'playable.timeline.errorBlock': 'Màn không tải được — vẫn chọn hoặc xoá được ở đây.',
  'playable.timeline.errorBadge': 'Lỗi',
  'playable.timeline.secondsLabel': 'Giây:',
  'playable.timeline.playhead': 'Con trỏ thời gian',
  'playable.timeline.playheadHint': 'Kéo trên thước (hoặc phím mũi tên) để xem quảng cáo ở đúng thời điểm đó',
  'playable.timeline.clearDelay': 'Bỏ hẹn giờ',
  'playable.timeline.videoTotal': 'Video ~{n}s',
  'playable.timeline.videoTotalHint': 'Độ dài video nếu xuất ngay bây giờ (màn chạm tính 2 giây).',
  'playable.timeline.tapVideoHint': '{n}s (video)',

  // Trình chỉnh sửa canvas (routes/admin-playable-screens-editor-panel.tsx và playable-editor-*.tsx)
  'playable.editor.newScreen': 'Màn hình mới (trình chỉnh sửa)',
  'playable.editor.title': 'Trình chỉnh sửa màn hình',
  'playable.editor.adSize': 'Kích thước quảng cáo (WxH)',
  'playable.editor.save.missingFields': 'Tên và slug là bắt buộc',
  'playable.editor.toolbar.add.text': 'Văn bản',
  'playable.editor.toolbar.add.box': 'Hộp',
  'playable.editor.toolbar.add.button': 'Nút bấm',
  'playable.editor.toolbar.add.progress': 'Thanh tiến trình',
  'playable.editor.toolbar.add.image': 'Hình ảnh',
  'playable.editor.toolbar.add.line': 'Đường kẻ',
  'playable.editor.toolbar.delete': 'Xóa phần tử đã chọn',
  'playable.editor.properties.empty': 'Chọn một phần tử trên canvas để chỉnh thuộc tính.',
  'playable.editor.properties.color': 'Màu chữ',
  'playable.editor.properties.background': 'Nền',
  'playable.editor.gradient.solid': 'Màu đơn',
  'playable.editor.gradient.gradient': 'Gradient',
  'playable.editor.gradient.custom': 'Tùy chỉnh (giữ nguyên)',
  'playable.editor.gradient.type': 'Kiểu',
  'playable.editor.gradient.linear': 'Tuyến tính',
  'playable.editor.gradient.radial': 'Tỏa tròn',
  'playable.editor.gradient.angle': 'Góc (°)',
  'playable.editor.gradient.color1': 'Màu đầu của gradient',
  'playable.editor.gradient.color2': 'Màu cuối của gradient',
  'playable.editor.properties.borderColor': 'Màu viền',
  'playable.editor.properties.fillColor': 'Màu tô',
  'playable.editor.properties.fontSize': 'Cỡ chữ',
  'playable.editor.properties.fontWeight': 'Độ đậm chữ',
  'playable.editor.properties.textAlign': 'Căn chữ',
  'playable.editor.properties.borderRadius': 'Bo góc',
  'playable.editor.properties.padding': 'Lề chữ (px)',
  'playable.editor.properties.borderWidth': 'Độ dày viền',
  'playable.editor.properties.opacity': 'Độ mờ',
  'playable.editor.effect.textOnly': 'Chỉ chạy hiệu ứng cho chữ, không chạy cả nút',
  'adsv2.build.sections.addOverlay': 'Thêm lớp phủ',
  'adsv2.build.sections.overlay': 'Lớp phủ',
  'adsv2.build.sections.removeOverlay': 'Bỏ lớp phủ',
  'adsv2.build.sections.overlayHint': 'Một lớp màu phủ lên nền và nằm dưới mọi thứ khác — cách làm mờ ảnh để chữ đọc được.',
  'adsv2.build.sections.backgroundRotateGone': 'Muốn xoay thì cần ảnh gốc như lúc chọn; hãy chọn lại ảnh để xoay.',
  'adsv2.build.sections.backgroundRotate': 'Xoay ảnh từng góc 90° — ảnh ngang ghép vào quảng cáo dọc',
  'playable.editor.paint.dimmed': 'Phần tử này đang để độ mờ {pct}%, nên nền, viền và mọi thứ bên trong đều vẽ nhạt theo.',
  'playable.editor.paint.dimmedReset': 'Về 100%',
  'playable.editor.properties.opacityHint': 'Áp cho cả phần tử và mọi thứ bên trong — nhóm để 10% thì nền, viền và các phần tử con đều còn 10%. Ô % cạnh màu là độ mờ riêng của màu đó, hai giá trị nhân với nhau.',
  'playable.editor.properties.tag': 'Cấp tiêu đề',
  'playable.editor.properties.text': 'Nội dung',
  'playable.editor.properties.image': 'File ảnh',
  'playable.editor.properties.currentFile': 'File hiện tại',
  'playable.editor.properties.imageInvalidType': 'File không phải ảnh PNG, JPEG, hoặc WebP hợp lệ',
  'playable.editor.properties.imageTooLarge': 'Ảnh quá nặng (tối đa 2 MB)',
  'playable.editor.properties.tint': 'Đổi màu icon',
  'playable.editor.properties.tintSwatch': 'Chọn màu để tô icon',
  'playable.editor.properties.tintHex': 'Mã màu để tô icon (hex)',
  'playable.editor.properties.tintApply': 'Tô màu',
  'playable.editor.properties.tintWorking': 'Đang tô…',
  'playable.editor.properties.tintHint': 'Tô lại ảnh thành một màu, giữ nguyên hình. Hợp với icon và hình một màu; ảnh nhiều màu sẽ thành một mảng màu. Hoàn tác được.',
  'playable.editor.properties.tintFailed': 'Không tô được màu cho ảnh này.',
  'playable.editor.properties.tintTooLarge': 'Ảnh quá lớn để tô màu (tối đa khoảng 4 triệu điểm ảnh).',
  'playable.editor.properties.tintAnimated': 'Đây là ảnh động (nhiều khung hình): tô màu sẽ làm nó đứng yên một khung, nên không tô. Dùng ảnh tĩnh để tô màu.',
  'playable.editor.properties.tintResultTooLarge': 'Ảnh sau khi tô nặng hơn 2 MB, giới hạn của một ảnh. Dùng ảnh ít điểm ảnh hơn để tô.',
  'playable.editor.properties.tintNoPicture': 'Chọn một ảnh cho phần tử này trước khi đổi màu.',
  'playable.editor.align.group': 'Nhóm',
  'playable.editor.align.ungroup': 'Bỏ nhóm',
  'playable.editor.align.groupHint': 'Chọn nhiều phần tử (Shift+click, hoặc kéo khung trên nền trống) rồi Nhóm. Nhóm là một hộp ôm các phần tử con: kéo nhóm là kéo cả con; chỉnh nền/viền/bo góc/độ mờ và bố cục ở thẻ của nhóm.',
  'playable.editor.group.title': 'Nhóm ({n} phần tử)',
  'playable.editor.group.name': 'Tên nhóm',
  'playable.editor.group.namePlaceholder': 'vd: Khối CTA',
  'playable.editor.toolbar.duplicate': 'Nhân bản',
  'playable.editor.align.duplicateHint': 'Nhân bản phần tử/nhóm đang chọn (Ctrl+D). Bản sao đặt lệch 16px, nhóm mang theo các phần tử con.',
  'playable.editor.align.succession': 'Nối tiếp',
  'playable.editor.align.successionHint': 'Cho các phần tử đang chọn chạy hiệu ứng lần lượt thay vì cùng lúc: chỉ đặt lại độ trễ (mỗi phần tử cách nhau 180ms, theo thứ tự vẽ), hiệu ứng và thời lượng giữ nguyên. Cần ít nhất 2 phần tử đang chọn có hiệu ứng.',
  'playable.editor.group.inGroup': 'trong nhóm',
  'playable.editor.group.layout': 'Bố cục',
  'playable.editor.group.direction.none': 'Tự do (ôm theo con)',
  'playable.editor.group.direction.row': 'Hàng ngang',
  'playable.editor.group.direction.column': 'Cột dọc',
  'playable.editor.group.align': 'Căn',
  'playable.editor.group.align.start': 'Đầu',
  'playable.editor.group.align.center': 'Giữa',
  'playable.editor.group.align.end': 'Cuối',
  'playable.editor.group.gap': 'Cách (px)',
  'playable.editor.group.alignment': 'Căn trong nhóm',
  'playable.editor.group.alignmentHint': 'Vị trí các phần tử con trong khung nhóm (khi khung rộng hơn nội dung). Hàng: cột = dọc theo hàng, hàng = trục ngang; Cột: ngược lại.',
  'playable.editor.padding.title': 'Lề trong',
  'playable.editor.padding.horizontal': 'Lề ngang (trái/phải)',
  'playable.editor.padding.vertical': 'Lề dọc (trên/dưới)',
  'playable.editor.padding.top': 'Lề trên',
  'playable.editor.padding.right': 'Lề phải',
  'playable.editor.padding.bottom': 'Lề dưới',
  'playable.editor.padding.left': 'Lề trái',
  'playable.editor.padding.expand': 'Tách 4 cạnh',
  'playable.editor.padding.collapse': 'Gộp ngang/dọc',
  'playable.editor.group.padding': 'Lề trong (px)',
  'playable.editor.group.hint': 'Hàng ngang/Cột dọc xếp các phần tử con theo thứ tự lớp; nhóm tự co theo con. Nền, viền, bo góc, độ mờ của nhóm chỉnh ở các ô bên dưới.',
  'playable.editor.group.rename': 'Đổi tên nhóm',
  'playable.editor.group.direction.wrap': 'Xuống dòng',
  'playable.editor.layout.title': 'Bố cục tự động',
  'playable.editor.layout.flow': 'Luồng',
  'playable.editor.layout.resizing': 'Co giãn',
  'playable.editor.layout.sizing.w': 'Chiều rộng',
  'playable.editor.layout.sizing.h': 'Chiều cao',
  'playable.editor.layout.sizing.fixed': 'Cố định',
  'playable.editor.layout.sizing.hug': 'Ôm nội dung',
  'playable.editor.layout.sizing.fill': 'Lấp đầy khung',
  'playable.editor.layout.sizing.fixed.w': 'Rộng cố định ({n})',
  'playable.editor.layout.sizing.fixed.h': 'Cao cố định ({n})',
  'playable.editor.layout.sizing.addMin.w': 'Thêm rộng tối thiểu…',
  'playable.editor.layout.sizing.addMax.w': 'Thêm rộng tối đa…',
  'playable.editor.layout.sizing.addMin.h': 'Thêm cao tối thiểu…',
  'playable.editor.layout.sizing.addMax.h': 'Thêm cao tối đa…',
  'playable.editor.layout.sizing.removeMin.w': 'Bỏ rộng tối thiểu',
  'playable.editor.layout.sizing.removeMax.w': 'Bỏ rộng tối đa',
  'playable.editor.layout.sizing.removeMin.h': 'Bỏ cao tối thiểu',
  'playable.editor.layout.sizing.removeMax.h': 'Bỏ cao tối đa',
  'playable.editor.layout.sizing.min.w': 'Rộng tối thiểu',
  'playable.editor.layout.sizing.max.w': 'Rộng tối đa',
  'playable.editor.layout.sizing.min.h': 'Cao tối thiểu',
  'playable.editor.layout.sizing.max.h': 'Cao tối đa',
  'playable.editor.geometry.position': 'Vị trí & kích thước',
  'playable.editor.geometry.lockRatio': 'Khoá tỉ lệ (hoặc giữ Shift khi kéo). Với chữ, nút và nhóm, kéo tay nào cũng phóng cả chữ lẫn phần tử bên trong; gõ W/H chỉ đổi khung.',
  'playable.editor.canvas.scaleHandle': 'Kéo để phóng to / thu nhỏ cả chữ và mọi thứ bên trong. Muốn chỉ đổi khung chữ: kéo mép.',
  'playable.editor.geometry.placedByFlow': 'Do bố cục nhóm đặt — kéo hoặc dùng phím mũi tên để đổi thứ tự',
  'playable.editor.geometry.thinHint': 'Hộp thường có thể mỏng tới 0.5 ở một cạnh (cạnh kia từ 8 trở lên) để làm đường kẻ. Dưới 1 chỉ mảnh hơn 1 trên điện thoại hay màn Retina thật; màn thường, ảnh và video xuất ra vẽ như 1.',
  'playable.editor.geometry.rotation': 'Xoay (°)',
  'playable.editor.geometry.rotate90': 'Xoay 90°',
  'playable.editor.geometry.flipX': 'Lật ngang',
  'playable.editor.geometry.flipY': 'Lật dọc',
  'playable.editor.geometry.radius': 'Bo góc',
  'playable.editor.geometry.cornersToggle': 'Bo từng góc riêng',
  'playable.editor.geometry.corner.tl': 'Góc trên trái',
  'playable.editor.geometry.corner.tr': 'Góc trên phải',
  'playable.editor.geometry.corner.bl': 'Góc dưới trái',
  'playable.editor.geometry.corner.br': 'Góc dưới phải',
  'playable.editor.paint.fill': 'Nền (Fill)',
  'playable.editor.paint.stroke': 'Viền (Stroke)',
  'playable.editor.paint.add': 'Thêm',
  'playable.editor.paint.remove': 'Bỏ',
  'playable.editor.paint.toggle': 'Ẩn/hiện',
  'playable.editor.paint.toGradient': 'Chuyển thành gradient',
  'playable.editor.paint.fillLeftOut': 'Chữ đang tô gradient, còn nền này không phải mã màu hex, rgb()/hsl() viết bằng số (như rgb(37, 99, 235)), transparent hay gradient của editor nên không được vẽ phía dưới chữ. Đổi sang một trong các dạng đó để thấy nền.',
  'playable.editor.stroke.position': 'Vị trí',
  'playable.editor.stroke.position.inside': 'Trong',
  'playable.editor.stroke.position.center': 'Giữa',
  'playable.editor.stroke.position.outside': 'Ngoài',
  'playable.editor.stroke.weight': 'Độ dày',
  'playable.editor.stroke.weightHint': 'Dưới 1 là mảnh hơn một điểm ảnh CSS. Điện thoại và màn Retina thật (2x, 3x) vẽ được nét mảnh hơn 1; màn máy tính thường (1x) vẽ mọi giá trị dưới 1 như 1, và ảnh, video xuất ra cũng vậy. Muốn nhạt hơn thì giảm Opacity.',
  'playable.editor.stroke.sides': 'Cạnh',
  'playable.editor.stroke.sides.all': 'Tất cả',
  'playable.editor.stroke.sides.top': 'Trên',
  'playable.editor.stroke.sides.bottom': 'Dưới',
  'playable.editor.stroke.sides.left': 'Trái',
  'playable.editor.stroke.sides.right': 'Phải',
  'playable.editor.stroke.sides.custom': 'Tuỳ chỉnh',
  'playable.editor.stroke.sidesInsideOnly': 'Chọn cạnh chỉ áp dụng với viền "Trong"',
  'playable.editor.typography.title': 'Chữ (Typography)',
  'playable.editor.typography.family': 'Font',
  'playable.editor.typography.familyScreen': 'Theo màn hình',
  'playable.editor.typography.weightDefault': 'Độ đậm mặc định',
  'playable.editor.typography.weight': 'Độ đậm',
  'playable.editor.typography.weightHint': 'Mỗi font an toàn chỉ có hai độ đậm thật (thường và đậm). Các mức còn lại là mức đậm vẽ thêm, giống nhau trên mọi máy và trong ảnh, video xuất ra. Chưa có mức nhạt (light): cần thêm font.',
  'playable.editor.typography.gradientLetters': 'Chữ này có hiệu ứng chạy từng chữ nên chưa hiện được gradient: chữ đang dùng màu đầu của gradient. Bỏ hiệu ứng đó để thấy gradient.',
  'playable.editor.typography.gradientClip': 'Gradient chỉ vẽ trong khung của chữ: phần chữ nằm ngoài khung không hiện. Cao dòng thấp (dưới 115%; font Verdana, Tahoma, Impact cần tới 125%), khung thấp hơn nội dung (tính lề trong, viền trong và các dòng chữ tự xuống dòng) hoặc khung ôm khít chữ mà giãn chữ âm sẽ làm dấu tiếng Việt chồng cao, đuôi chữ (g, j, y) hay chữ cuối bị cắt. Tăng cao dòng hoặc nới khung.',
  'playable.editor.typography.weight400': 'Thường (400)',
  'playable.editor.typography.weight500': 'Vừa (500)',
  'playable.editor.typography.weight600': 'Hơi đậm (600)',
  'playable.editor.typography.weight700': 'Đậm (700)',
  'playable.editor.typography.weight800': 'Rất đậm (800)',
  'playable.editor.typography.weight900': 'Siêu đậm (900)',
  'playable.editor.typography.lineHeight': 'Cao dòng (%)',
  'playable.editor.typography.letterSpacing': 'Giãn chữ (%)',
  'playable.editor.typography.alignment': 'Căn chữ',
  'playable.editor.typography.verticalAlign': 'Căn dọc',
  'playable.editor.typography.alignLeft': 'Căn trái',
  'playable.editor.typography.alignCenter': 'Căn giữa',
  'playable.editor.typography.alignRight': 'Căn phải',
  'playable.editor.typography.alignJustify': 'Căn đều hai bên (dòng cuối, và dòng ngắt bằng Enter, vẫn căn trái)',
  'playable.editor.typography.alignTop': 'Căn trên',
  'playable.editor.typography.alignMiddle': 'Căn giữa theo chiều dọc',
  'playable.editor.typography.alignBottom': 'Căn dưới',
  'playable.editor.typography.decoration': 'Gạch chân / gạch ngang',
  'playable.editor.typography.decorationNone': 'Không gạch',
  'playable.editor.typography.decorationUnderline': 'Gạch chân',
  'playable.editor.typography.decorationStrikethrough': 'Gạch ngang chữ',
  'playable.editor.typography.case': 'Chữ hoa / thường',
  'playable.editor.typography.caseNone': 'Như đã gõ',
  'playable.editor.typography.caseUpper': 'CHỮ HOA',
  'playable.editor.typography.caseLower': 'chữ thường',
  'playable.editor.typography.caseTitle': 'Viết Hoa Chữ Đầu Mỗi Từ',
  'playable.editor.typography.caseSmallCaps': 'Chữ hoa nhỏ (small caps)',
  'playable.editor.canvas.resize': 'Kéo để phóng to/thu nhỏ khung (giữ tỉ lệ). Chỉ là zoom — ad vẫn 320×480.',
  'playable.editor.canvas.readOnly': 'Màn này chỉ xem — chọn phần tử được, không kéo được.',
  'playable.editor.advance.title': 'Advance',
  'playable.editor.advance.tapTargeted': 'Nhấn nút/vùng chỉ định',
  'playable.editor.advance.tapTarget': 'Phần tử kích hoạt',
  'playable.editor.advance.tapNoElements': 'Thêm một phần tử trước',
  'playable.editor.advance.tapAnywhere': 'Nhấn bất kỳ đâu',
  'playable.editor.advance.auto': 'Tự động chuyển màn',
  'playable.editor.advance.autoSeconds': 'Số giây',
  'playable.editor.advance.exit': 'Thoát (màn cuối)',
  'playable.editor.advance.tapDelayLabel': 'Nếu không nhấn, tự qua sau',
  'playable.editor.advance.tapDelayHint': 'giây, tối đa {n}s (trống = chờ mãi)',
  'playable.editor.advance.autoSecondsHint': 'tối đa {n}s',
  'playable.editor.advance.clearDelay': 'Bỏ hẹn giờ',
  'playable.editor.advance.elementFallback': 'Phần tử {n}',
  'playable.editor.advance.kind.text': 'Chữ',
  'playable.editor.advance.kind.box': 'Hộp',
  'playable.editor.advance.kind.line': 'Đường kẻ',
  'playable.editor.advance.kind.button': 'Nút',
  'playable.editor.advance.kind.progress': 'Tiến trình',
  'playable.editor.advance.kind.image': 'Ảnh',
  'playable.editor.undo': 'Hoàn tác',
  'playable.editor.redo': 'Làm lại',
  'playable.editor.save.invalidSlug': 'Slug phải viết thường dạng kebab-case (vd: man-hinh-cua-toi)',
  'playable.editor.save.payloadTooLarge': 'Dữ liệu màn hình nặng {mb} MB; giới hạn là ~8 MB — hãy giảm dung lượng ảnh',
  'playable.editor.effect': 'Animation vào',
  'playable.editor.effect.group.general': 'Chung',
  'playable.editor.effect.group.text': 'Chữ',
  'playable.editor.effect.group.progress': 'Thanh chạy',
  'playable.editor.effect.none': 'Không có',
  'playable.editor.effect.duration': 'Thời lượng (ms)',
  'playable.editor.effect.delay': 'Độ trễ (ms)',
  'playable.editor.effect.appearAfter': 'Hiện sau (giây)',
  'playable.editor.effect.appearAfterHint': 'Phần tử ẩn và không nhận chạm cho tới giây này, tính từ lúc màn hiện ra. Dùng được cả khi không chọn animation.',
  'playable.editor.effect.appearAfterHintGroup': 'Chỉ khung của nhóm ẩn tới giây này, tính từ lúc màn hiện ra. Tích “Áp dụng cho mọi phần tử trong nhóm” để cả các phần tử bên trong cũng ẩn và không nhận chạm.',
  'playable.editor.effect.appearAfterHintEnd': 'Phần tử ẩn cho tới giây này, tính từ lúc màn hiện ra. Màn cuối: chạm chỗ nào cũng mở store, kể cả chỗ phần tử chưa hiện.',
  'playable.editor.effect.appearAfterOff': 'Animation này không giấu phần tử trước khi chạy nên không có Hiện sau. Chọn Không có hoặc một kiểu vào như Mờ dần hiện ra. Độ trễ dưới đây chỉ dời lúc nó bắt đầu chạy.',
  'playable.editor.effect.appearOnTimeline': 'Trên timeline: hiện ở giây thứ {s}',
  'playable.editor.effect.appearTooLate': 'Màn này chuyển sau {s} giây nên phần tử chưa kịp hiện.',
  'playable.editor.effect.appearTooLateVideo': 'Video chỉ giữ màn này {s} giây nên không thấy phần tử này. Người chơi thật vẫn thấy khi màn còn đó.',
  'playable.editor.effect.intensity': 'Cường độ (%)',
  'playable.editor.effect.preset.fade-in': 'Mờ dần hiện ra',
  'playable.editor.effect.preset.slide-in-left': 'Trượt vào từ trái',
  'playable.editor.effect.preset.slide-in-right': 'Trượt vào từ phải',
  'playable.editor.effect.preset.slide-in-up': 'Trượt vào từ dưới',
  'playable.editor.effect.preset.pulse': 'Nhấp nháy phóng to',
  'playable.editor.effect.preset.rise': 'Dâng lên',
  'playable.editor.effect.preset.pan': 'Lướt ngang vào',
  'playable.editor.effect.preset.pop': 'Bật ra',
  'playable.editor.effect.preset.wipe': 'Gạt mở dần',
  'playable.editor.effect.preset.blur': 'Mờ thành nét',
  'playable.editor.effect.preset.baseline': 'Trồi lên từ vạch',
  'playable.editor.effect.preset.breathe': 'Phình nhẹ rồi lắng',
  'playable.editor.effect.preset.drift': 'Trôi ngang chậm',
  'playable.editor.effect.preset.tumble': 'Xoay rơi vào',
  'playable.editor.effect.preset.stomp': 'Giáng xuống',
  'playable.editor.effect.preset.merge': 'Chữ dồn lại',
  'playable.editor.effect.preset.spread': 'Chữ giãn ra',
  'playable.editor.effect.preset.block': 'Thanh màu quét qua chữ',
  'playable.editor.effect.preset.typewriter': 'Gõ từng chữ',
  'playable.editor.effect.preset.ascend': 'Từng chữ dâng lên',
  'playable.editor.effect.preset.bounce': 'Từng chữ nảy xuống',
  'playable.editor.effect.preset.shift': 'Từng chữ trượt ngang',
  'playable.editor.effect.preset.burst': 'Từng chữ bung ra',
  'playable.editor.effect.preset.roll': 'Từng chữ lăn vào',
  'playable.editor.effect.preset.skate': 'Từng chữ lướt tới',
  'playable.editor.effect.preset.tectonic': 'Rơi xuống rung nền',
  'playable.editor.effect.preset.neon': 'Đèn neon bật sáng',
  'playable.editor.effect.preset.scrapbook': 'Thả xuống như ảnh dán',
  'playable.editor.effect.preset.flash': 'Chớp sáng',
  'playable.editor.effect.preset.progress-fill': 'Thanh chạy tô đầy',
  'playable.editor.effect.preset.progress-fill-striped': 'Thanh chạy tô đầy, sọc chạy',
  'playable.editor.effect.preset.progress-fill-shine': 'Thanh chạy tô đầy, vệt sáng lướt',
  'playable.editor.effect.preset.progress-fill-steps': 'Thanh chạy tô đầy, nhảy bậc',
  'playable.editor.effect.preset.progress-indeterminate': 'Thanh chạy vô hạn (không tô đầy)',
  'playable.editor.effect.progress': 'Kiểu chạy',
  'playable.editor.ai.title': 'Trợ lý AI',
  'playable.editor.ai.placeholder': 'Mô tả màn hình hoặc thành phần cần tạo…',
  'playable.editor.ai.generateScreen': 'Tạo màn hình',
  'playable.editor.ai.generateElement': 'Tạo thành phần',
  'playable.editor.ai.working': 'Đang tạo…',
  'playable.editor.ai.replaceHint': '“Tạo màn hình” thay toàn bộ thành phần (có thể hoàn tác). “Tạo thành phần” thêm một thành phần.',

  // Ads Builder v2 (routes/ads-builder-v2-*.tsx)
  'adsv2.title': 'Ads Builder',
  'adsv2.openSaved': 'Mở template đã lưu',
  'adsv2.duplicateTemplate': 'Nhân bản template',
  'adsv2.duplicateName': '{name} (bản sao)',
  'adsv2.duplicated': 'Đang sửa bản sao. Bản sao chỉ được giữ lại khi bạn bấm Lưu; template gốc không đổi.',
  'adsv2.opening': 'Đang mở template…',
  'adsv2.openReplaceConfirm': 'Mở template này sẽ thay phần đang dựng trên canvas; phần chưa lưu sẽ mất. Vẫn mở?',
  'adsv2.newTemplateConfirm': 'Bắt đầu template mới sẽ xoá phần đang dựng trên canvas; phần chưa lưu sẽ mất. Vẫn bắt đầu?',
  'adsv2.reopenFailed': 'Đã lưu template nhưng không mở lại được ({error}). Canvas đã được làm mới; mở template từ danh sách để sửa tiếp.',
  'adsv2.draft.restoring': 'Đang mở lại…',
  'adsv2.draft.saved': 'Đã lưu trên máy này lúc {time}',
  'adsv2.draft.failed': 'Trình duyệt không cho lưu — đóng tab là mất bản dựng.',
  'adsv2.draft.replaceConfirm': 'Mở lại bản cũ sẽ thay toàn bộ những gì đang dựng trên màn hình — phần đang dựng chưa được lưu và không lấy lại được. Vẫn mở lại?',
  'adsv2.draft.templateSuperseded': 'Template gốc đã được người khác lưu đè trong lúc bạn để dở — bản dựng này giờ là một template mới; lưu lại để giữ nó.',
  'adsv2.draft.screensDropped': '{n} màn không giữ được: màn gốc của chúng đã bị xoá cùng template hoặc chưa được công bố.',
  'adsv2.draft.screensDroppedSuperseded': '{n} màn không giữ được: màn gốc của chúng thuộc template cũ (đã bị người khác lưu đè) hoặc chưa được công bố.',
  'adsv2.draft.templateGone': 'Template gốc đã bị xoá — bản dựng này giờ là một template mới; lưu lại để giữ nó.',
  'adsv2.draft.savedGone': 'Đã lưu, nhưng bản vừa lưu không còn trên máy chủ (đã bị xoá). Bản dựng vẫn nằm trên canvas; lưu lại để giữ nó.',
  'adsv2.draft.libraryFailed': 'Không tải được màn từ thư viện ({error}) — các màn lấy từ thư viện sẽ báo lỗi cho tới khi tải lại trang.',
  'adsv2.picker.empty': 'Chưa có template nào.',
  'adsv2.picker.onServer': 'Chung (máy chủ)',
  'adsv2.picker.onThisDevice': 'Trên máy này',
  'adsv2.picker.localHint': 'Chỉ có trên trình duyệt này, của riêng bạn. Mở lại để dựng tiếp; đổi máy sẽ không thấy.',
  'adsv2.picker.open': 'Mở',
  'adsv2.picker.unnamed': '(chưa đặt tên)',
  'adsv2.picker.deleteLocalConfirm': 'Xoá bản “{name}” lưu trên máy này? Không khôi phục được.',
  'adsv2.build.saveLocal': 'Lưu trên máy',
  'adsv2.local.saved': 'Đã lưu bản này trên máy lúc {time}',
  'adsv2.local.failed': 'Trình duyệt không cho lưu trên máy — chọn “Của tôi (máy chủ)” hoặc “Chung (máy chủ)” để lưu lên máy chủ, hoặc tải về (ZIP) để giữ.',
  'adsv2.picker.screens': '{n} màn',
  'adsv2.picker.languages': '{n} ngôn ngữ',
  'adsv2.picker.delete': 'Xoá',
  'adsv2.picker.rename': 'Đổi tên',
  'adsv2.picker.renameGone': 'Template này không còn trên máy chủ (đã bị xoá).',
  'adsv2.picker.renameOwnGone': 'Bản này không còn trên máy chủ (đã bị xoá).',
  'adsv2.picker.offline': 'Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.',
  'adsv2.picker.requestFailed': 'Máy chủ không thực hiện được thao tác này (mã {code}).',
  'adsv2.picker.cover': 'Tạo ảnh bìa',
  'adsv2.picker.coverRefresh': 'Vẽ lại ảnh bìa',
  'adsv2.picker.coverWorking': 'Đang vẽ…',
  'adsv2.picker.coverFailed': 'Không vẽ được ảnh bìa (lý do ở console trình duyệt).',
  'adsv2.picker.coverSkipped': 'Bản này vừa được lưu lại; ảnh bìa mới hơn đã có hoặc đang được vẽ.',
  'adsv2.picker.deleteConfirm': 'Xoá “{name}” cùng {n} màn dựng trong nó? Không khôi phục được, và quảng cáo nào đang làm dở từ nó sẽ ngừng chạy.',
  'adsv2.form.screen': 'Màn {n}',
  'adsv2.form.previewLanguage': 'Ngôn ngữ xem trước',
  'adsv2.form.defaultLanguage': 'Mặc định',
  'adsv2.preview.pinned': 'Đang giữ màn {n} để bạn sửa.',
  'adsv2.preview.stillApprox': 'Xem thử xấp xỉ tại {s}s — không có hiệu ứng chuyển màn và chớp màn, lệch ±1 khung',
  'adsv2.preview.stillUnpin': 'Quay lại sửa',
  'adsv2.preview.stillBig': 'Bản xem thử lớn hơn 20 MB, có thể chậm',
  'adsv2.preview.play': 'Chạy thử quảng cáo',
  'adsv2.preview.stop': 'Dừng chạy thử',
  'adsv2.preview.sizeGuides': 'Khung ảnh/video',
  'adsv2.preview.sizeGuidesKind': 'Loại khung',
  'adsv2.preview.sizeGuides.both': 'Cả hai',
  'adsv2.preview.sizeGuides.image': 'Khung ảnh',
  'adsv2.preview.sizeGuides.video': 'Khung video',
  'adsv2.preview.sideLanguage': 'Ngôn ngữ khác',
  'adsv2.preview.sideLanguageHint': 'Mở thêm một khung chạy thử bên cạnh, chạy quảng cáo bằng một ngôn ngữ đã chọn ở mục Ngôn ngữ. Khung cập nhật theo từng thay đổi; chữ chưa dịch hiện bản gốc.',
  'adsv2.preview.sizeGuidesHint': 'Bật/tắt khung phần quảng cáo còn giữ lại ở MỌI kích thước xuất được — ảnh (xanh) 1:1, 1.91:1, 4:5 và video (cam) 1:1, 16:9, 9:16 — khi cắt cho đầy khung. Không phụ thuộc kích thước đang tick ở tab tải về. Kích thước trùng tỉ lệ quảng cáo thì không mất phần nào nên không có khung.',
  'adsv2.preview.portrait': 'Dọc',
  'adsv2.preview.landscape': 'Ngang',
  'adsv2.export.tab.html': 'Playable',
  'adsv2.export.tab.image': 'Ảnh',
  'adsv2.export.tab.video': 'Video',
  'adsv2.export.htmlHint': 'File ZIP tải thẳng lên Google Ads.',
  'adsv2.export.imageHint': 'Mỗi kích thước một ảnh, chạy lần lượt từng cái.',
  'adsv2.export.videoHint': 'Chạy hết quảng cáo: mỗi màn giữ đúng số giây đã đặt; màn chờ chạm mà không hẹn giờ thì tính 2 giây.',
  'adsv2.export.whichSizes': 'Xuất kích thước nào',
  'adsv2.export.imageFit': 'Khớp khung ảnh',
  'adsv2.export.imageTime': 'Thời điểm (giây trên timeline video)',
  'adsv2.export.imageTimeScreen': 'Màn {n} · {name} · giây {s} của màn',
  'adsv2.export.videoFit': 'Khớp khung video (phần playable)',
  'adsv2.export.fit.cover': 'Cắt cho đầy khung — không còn viền đen',
  'adsv2.export.fit.contain': 'Giữ trọn quảng cáo — có viền hai bên',
  'adsv2.export.cropNote': 'Cắt sẽ mất phần mép. Giữ lại được:',
  'adsv2.export.videoSize': 'Kích thước video',
  'adsv2.export.endDwell': 'Giữ màn cuối (giây)',
  'adsv2.export.videoTotal': 'Tổng: {n}s',
  'adsv2.export.tapDwellNote': 'màn chạm — 2s',
  'adsv2.export.videoTooLong': 'Video dài hơn trần cho phép — rút bớt màn hoặc giây mỗi màn.',
  'adsv2.export.loadSlack': '+ {n}s tải trang',
  'adsv2.export.warn.midExit': 'Màn {n} thoát giữa chuỗi — video sẽ dừng ở đó.',
  'adsv2.export.warn.overMax': 'Video dài {s}s, vượt trần {max}s — rút bớt màn hoặc giây mỗi màn.',
  'adsv2.export.warn.long': 'Video dài hơn 20s — Google khuyến nghị 10–30s.',
  'adsv2.export.warn.short': 'Video ngắn hơn 10s — Google khuyến nghị 10–30s.',
  'adsv2.export.warn.missingScreen': 'Màn {n} không tải được — sửa hoặc xóa màn đó trước khi xuất video.',
  'adsv2.export.downloadZip': 'Tải ZIP',
  'adsv2.export.downloadImage': 'Tải ảnh {size} (.zip)',
  'adsv2.export.downloadImages': 'Tải {n} ảnh (.zip)',
  'adsv2.export.downloadVideos': 'Tải {n} video (.zip)',
  'adsv2.export.noSize': 'Chọn ít nhất một kích thước',
  'adsv2.export.stopping': 'Đang dừng…',
  'adsv2.export.downloadVideo': 'Tải video {size}',
  'adsv2.export.videoMultiNote': 'Dựng {n} video lần lượt, mỗi cái mất khoảng thời lượng clip cộng thời gian chuyển mã. Tải về một file ZIP.',
  'adsv2.export.cancel': 'Dừng',
  'adsv2.export.assembly.title': 'Nối clip và nhạc nền',
  'adsv2.export.assembly.hint': 'Ghép ngay trên máy này, không tải file nào lên server, không lưu lại sau khi tải trang.',
  'adsv2.export.assembly.part': 'Đang chỉnh phần nào',
  'adsv2.export.assembly.pre': 'Các clip trước quảng cáo',
  'adsv2.export.assembly.post': 'Các clip sau quảng cáo',
  'adsv2.export.assembly.defaultSet': 'Mặc định / bản gốc',
  'adsv2.export.assembly.langUsesDefault': 'Để trống thì ngôn ngữ này dùng đúng danh sách clip mặc định.',
  'adsv2.export.assembly.music': 'Nhạc nền — xếp nối tiếp nhau bên dưới',
  'adsv2.export.assembly.remove': 'Bỏ',
  'adsv2.export.assembly.moveUp': 'Lên',
  'adsv2.export.assembly.moveDown': 'Xuống',
  'adsv2.export.assembly.choose.video': 'Thêm video… hoặc kéo thả vào đây',
  'adsv2.export.assembly.choose.audio': 'Thêm nhạc… hoặc kéo thả vào đây',
  'adsv2.export.assembly.reading': 'Đang đọc file…',
  'adsv2.export.assembly.keepAudio': 'Giữ tiếng của clip (nhạc tự nhỏ lại khi clip có tiếng)',
  'adsv2.export.assembly.fit': 'Clip khác khung video',
  'adsv2.export.assembly.fit.contain': 'Giữ trọn clip — có viền',
  'adsv2.export.assembly.fit.cover': 'Cắt cho đầy khung',
  'adsv2.export.assembly.fadeLabel': 'Mờ dần đầu/cuối (giây)',
  'adsv2.export.assembly.fadeHint': 'Nhạc mờ dần từ im lặng lên hết âm lượng trong khoảng thời gian này ở track đầu tiên, và mờ dần xuống im lặng trong cùng khoảng đó ở cuối track cuối cùng.',
  'adsv2.export.assembly.trackStart': 'Bắt đầu',
  'adsv2.export.assembly.trimHead': 'Cắt đầu',
  'adsv2.export.assembly.trimTail': 'Cắt cuối',
  'adsv2.export.assembly.clipBefore': 'clip {n} trước',
  'adsv2.export.assembly.clipAfter': 'clip {n} sau',
  'adsv2.export.assembly.langTotalsTitle': 'Thời lượng từng bản',
  'adsv2.export.assembly.langTotalsHint': 'Mỗi ngôn ngữ có thể dùng clip riêng (chọn ngôn ngữ ở ô "Đang chỉnh phần nào" bên trên). Nhạc vẫn phát qua một bản ngắn hơn nhưng bị cắt đúng ở điểm bản đó kết thúc.',
  'adsv2.export.assembly.total': 'Tổng {total} / tối đa {max}',
  'adsv2.export.assembly.tooLong': 'dài quá {max}, chọn clip ngắn hơn',
  'adsv2.export.assembly.progressRow': 'đang ghép {pct}%',
  'adsv2.export.assembly.unsupported': 'Trình duyệt này không ghép được video. Dùng Chrome bản mới.',
  'adsv2.export.assembly.err.unreadable': 'Không đọc được file này.',
  'adsv2.export.assembly.err.no-video': 'File này không có hình.',
  'adsv2.export.assembly.err.no-audio': 'File này không có tiếng.',
  'adsv2.export.assembly.err.video-codec': 'Chrome không giải mã được hình của clip này ({codec}). Xuất lại clip sang H.264 rồi chọn lại.',
  'adsv2.export.assembly.err.audio-codec': 'Chrome không giải mã được tiếng của file này ({codec}).',
  'adsv2.export.assembly.err.load-failed': 'Không tải được bộ xử lý video. Tải lại trang rồi thử lại.',
  'adsv2.export.assembly.ad': 'Video quảng cáo',
  'adsv2.export.assembly.playheadClip': '{name} · giây {s}',
  'adsv2.export.assembly.playheadAd': 'Quảng cáo · xem thử xấp xỉ, mối nối clip có thể hiện đen như file xuất',
  'adsv2.export.assembly.fail.ad-no-picture': 'Không đọc được hình trong video quảng cáo vừa quay. Bấm xuất lại để quay mới.',
  'adsv2.export.assembly.fail.clip-no-picture': '{detail}: file không có hình.',
  'adsv2.export.assembly.fail.too-long': 'Tổng dài {detail}, quá 5 phút.',
  'adsv2.export.assembly.fail.empty-clip': '{detail}: quá ngắn, không đủ một khung hình.',
  'adsv2.export.assembly.fail.no-canvas': 'Trình duyệt này không vẽ được khung hình video.',
  'adsv2.export.assembly.fail.empty-output': 'Video ghép ra bị rỗng.',
  'adsv2.export.assembly.reused': 'Dùng lại video quảng cáo đã quay trong phiên này cho {sizes}, không quay lần nữa. Muốn quay mới thì xuất một lần không kèm clip và nhạc.',
  'adsv2.export.working': 'Đang chuẩn bị…',
  'adsv2.export.rendering': 'Đang dựng…',
  'adsv2.export.state.pending': 'đang chờ',
  'adsv2.export.state.running': 'đang dựng',
  'adsv2.export.state.done': 'xong',
  'adsv2.export.state.error': 'lỗi',
  'adsv2.export.state.cancelled': 'đã dừng',
  // Chế độ dựng template (admin)
  'adsv2.build.title': 'Template mới',
  'adsv2.build.newTemplate': 'Tạo template mới từ trang trắng',
  'adsv2.import.skipped': '{n} ảnh bỏ lại vì vượt ngân sách 2 MB khi import — tải zip nếu cần đủ.',
  'adsv2.build.font': 'Font toàn quảng cáo',
  'adsv2.build.adSizeConfirm': 'Đổi kích cỡ sẽ kẹp lại vị trí/kích thước mọi phần tử trên MỌI màn vào khung mới. Màn lấy từ thư viện và ảnh nền đã ghép không được kẹp lại — có thể phải chọn lại. Tiếp tục?',
  'adsv2.cover.label': 'Ảnh bìa',
  'adsv2.cover.default': 'Mặc định: cuối màn đầu',
  'adsv2.cover.at': 'Khung ~{s} giây',
  'adsv2.cover.reset': 'Về khung mặc định',
  'adsv2.cover.hint': 'Ảnh hiện ở danh sách template. Ghim một khung trên thước thời gian rồi bấm “Đặt làm ảnh bìa”; mỗi lần lưu, ảnh được vẽ lại ở khung này.',
  'adsv2.cover.set': 'Đặt làm ảnh bìa',
  'adsv2.cover.setHint': 'Khung này thành ảnh bìa khi lưu template.',
  'adsv2.cover.isCover': 'Đang là ảnh bìa',
  'adsv2.cover.working': 'Đang vẽ ảnh bìa…',
  'adsv2.cover.failed': 'Chưa vẽ được ảnh bìa — bản này vẫn đã lưu.',
  'adsv2.build.downloadName': 'Tên file tải về',
  'adsv2.build.downloadNameHint': 'Tên chung cho mọi file tải: NP34 thành NP34-HTML, NP34-IMG, NP34-MP4. Để trống thì dùng tên template.',
  'adsv2.build.fontLibraryNote': 'Màn tham chiếu từ thư viện giữ font riêng đã lưu của nó.',
  'adsv2.build.export.disabledSkipped': 'Có màn không hiện được trong quảng cáo — sửa trước khi tải xuống, nếu không file sẽ thiếu màn.',
  'adsv2.build.save': 'Lưu vào Chung (máy chủ)',
  'adsv2.build.empty': 'Thêm một màn để bắt đầu dựng.',
  'adsv2.build.nameRequired': 'Đặt tên cho template.',
  'adsv2.build.namePrompt': 'Đặt tên cho template này',
  'adsv2.build.rename': 'Đổi tên template',
  'adsv2.build.renamePrompt': 'Tên mới cho template',
  'adsv2.build.needScreen': 'Cần ít nhất một màn.',
  'adsv2.build.lastMustExit': 'Màn cuối phải kết thúc quảng cáo — đó là cú chạm mở cửa hàng. Đặt cách qua màn của nó thành “Thoát”, hoặc chuyển một màn khác xuống sau nó.',
  'adsv2.build.fixLastExit': 'Đặt màn cuối thành kết thúc',
  'adsv2.build.advance.tap': 'khi bấm',
  'adsv2.build.advance.exit': 'kết thúc',
  'adsv2.build.fromLibrary': 'từ thư viện',
  'adsv2.build.editTitle': 'Đang sửa “{name}”',
  'adsv2.build.locked.library': 'Màn {n} ({name}) lấy từ thư viện dùng chung — tạo bản sao trước khi sửa.',
  'adsv2.build.locked.no-canvas-model': 'Màn {n} ({name}) không vẽ trên canvas này nên không sửa được ở đây. Nó vẫn nằm nguyên trong quảng cáo; muốn bỏ thì xoá màn đó.',
  'adsv2.build.locked.duplicate': 'Màn {n} ({name}) chính là màn đã dùng trước đó trong quảng cáo này. Sửa màn đầu tiên — cả hai cùng đổi.',
  'adsv2.build.missingScreen': 'Màn {n} không nạp được, nhưng vẫn nằm trong quảng cáo.',
  'adsv2.build.locked.missing': 'Màn {n} không nạp được. Nó vẫn nằm nguyên trong quảng cáo.',
  'adsv2.build.lockedPanel.library': 'Màn này lấy từ thư viện dùng chung. Sửa ở đây sẽ đổi mọi quảng cáo đang dùng nó, nên hãy tạo bản riêng cho template này trước.',
  'adsv2.build.lockedPanel.no-canvas-model': 'Màn này dựng trong template nhưng không vẽ trên canvas này, mở ra sẽ thấy màn trống. Nó được giữ nguyên — muốn bỏ thì xoá màn đó.',
  'adsv2.build.lockedPanel.duplicate': 'Đây chính là màn đã dùng trước đó trong quảng cáo. Sửa ở chỗ đó — cả hai cùng đổi.',
  'adsv2.build.lockedPanel.missing': 'Màn này không nạp được nên không hiện và không sửa được. Lưu vẫn giữ nó nguyên trong quảng cáo.',
  'adsv2.build.libraryLocked': 'Màn này lấy từ thư viện dùng chung. Sửa ở đây sẽ đổi mọi quảng cáo đang dùng nó, nên hãy tạo bản riêng cho template này trước.',
  'adsv2.build.fork': 'Tạo bản riêng cho template này',
  'adsv2.build.advanceOverrideBadge': 'Timeline đang ghi đè {s}s cho vị trí này, khác với thiết lập bên dưới.',
  'adsv2.build.advanceOverrideBadgeGeneric': 'Timeline đang ghi đè cách chuyển màn cho vị trí này, khác với thiết lập bên dưới.',
  // Form section (routes/ads-builder-v2-element-sections.tsx) — kiểu V1: mỗi element một hộp thu gọn
  'adsv2.build.sections.general': 'Thiết kế chung',
  'adsv2.build.sections.screenName': 'Tên màn',
  'adsv2.build.sections.maxTime': 'Thời gian tối đa (giây)',
  'adsv2.build.sections.maxTimeHint': 'Quá thời gian này màn tự chuyển sang màn kế.',
  'adsv2.build.sections.maxTimeExit': 'Màn cuối là màn kết thúc: đây là thời gian màn hiện trong Chạy thử và video (cùng giá trị với mục Tải).',
  'adsv2.build.sections.endTime': 'Thời gian hiện màn cuối (giây)',
  'adsv2.build.sections.translations': 'Ngôn ngữ',
  'adsv2.languages.hint': 'Chọn ngôn ngữ trong danh sách (chọn được nhiều, có tìm kiếm). Khi bấm tải, AI dịch những chữ còn thiếu, rồi tải ra bản gốc và mỗi ngôn ngữ một bản.',
  'adsv2.languages.translating': 'đang dịch…',
  'adsv2.languages.failed': 'chưa dịch xong',
  'adsv2.languages.retry': 'Dịch lại phần còn thiếu',
  'adsv2.languages.translateAll': 'Dịch ngay tất cả',
  'adsv2.languages.translateNow': 'Dịch ngay',
  'adsv2.languages.translateOne': 'Dịch ngay sang {name}',
  'adsv2.languages.translateHint': 'Bình thường AI chỉ dịch khi tải về. Bấm để dịch ngay, rồi xem bản dịch ở khung "Ngôn ngữ khác" bên cạnh canvas.',
  'adsv2.languages.translated': 'Đã dịch',
  'adsv2.languages.translatedHint': 'Ngôn ngữ này đã dịch đủ, không cần dịch lại. Khi bạn sửa chữ gốc, những câu đổi sẽ tự được đánh dấu cần dịch lại.',
  'adsv2.languages.fit': '{n} phần tử thu nhỏ',
  'adsv2.languages.fitHint': 'Chữ của ngôn ngữ này dài hơn khung nên hệ thống tự hạ cỡ chữ của riêng những phần tử đó cho vừa. Màu đỏ nghĩa là đã hạ tới mức tối thiểu mà vẫn chưa vừa — nên rút gọn câu hoặc nới khung.',
  'adsv2.languages.textScale': 'Cỡ chữ cho {name} (%)',
  'adsv2.languages.textScaleHint': 'Cỡ chữ của riêng ngôn ngữ này, so với cỡ đã thiết kế (100%). Câu cùng nghĩa ở mỗi ngôn ngữ dài ngắn khác nhau, nên có thể hạ xuống cho vừa khung. Chỉ chữ thay đổi; khung, ảnh và bố cục giữ nguyên.',
  'adsv2.languages.toEnglish': 'Dịch bản gốc sang tiếng Anh',
  'adsv2.languages.toEnglishRunning': 'Đang dịch sang tiếng Anh…',
  'adsv2.languages.toEnglishHint': 'Đổi toàn bộ chữ trên các màn của template này sang tiếng Anh, ngay trên canvas (không phải một bản ngôn ngữ). Màn dùng chung từ thư viện giữ nguyên. Hoàn tác được trên từng màn.',
  'adsv2.languages.toEnglishConfirm': 'Dịch {n} đoạn chữ trên các màn sang tiếng Anh? Chữ gốc trên canvas sẽ được thay bằng bản tiếng Anh.',
  'adsv2.languages.toEnglishNothing': 'Không có chữ nào để dịch.',
  'adsv2.languages.toEnglishDone': 'Đã đổi {n} đoạn sang tiếng Anh; {left} đoạn giữ nguyên.',
  'adsv2.languages.toEnglishFailed': 'Không dịch được: {error}',
  'adsv2.languages.pick': 'Chọn ngôn ngữ…',
  'adsv2.languages.pickedCount': 'Đã chọn {n} ngôn ngữ',
  'adsv2.languages.search': 'Tìm ngôn ngữ…',
  'adsv2.languages.noMatch': 'Không có ngôn ngữ nào khớp.',
  'adsv2.languages.remove': 'Bỏ {name}',
  'adsv2.export.translating': 'Đang dịch các ngôn ngữ…',
  'adsv2.export.untranslated': 'Chưa dịch được {langs}: những chữ còn thiếu dùng chữ gốc.',
  'adsv2.export.downloadZipLanguages': 'Tải ZIP (gốc + {n} ngôn ngữ)',
  'adsv2.export.downloadZipCopies': 'Tải ZIP ({n} bản)',
  'adsv2.export.originalCopy': 'gốc',
  'adsv2.export.videoTooMany': 'Tối đa {max} video mỗi lần tải; lựa chọn này là {n}. Bớt kích thước hoặc ngôn ngữ.',
  'adsv2.export.copies': 'Bản tải về',
  'adsv2.export.copiesHint': 'Chọn những bản muốn có trong lần tải này — bản gốc và/hoặc từng ngôn ngữ đã tích ở mục Ngôn ngữ. Mặc định tích hết; ngôn ngữ nào bỏ tích thì không dịch và không có trong file tải về.',
  'adsv2.export.noCopies': 'Chọn ít nhất một bản',
  'adsv2.build.sections.background': 'Nền màn',
  'adsv2.build.sections.addBackground': '+ Thêm nền',
  'adsv2.build.sections.removeBackground': 'Bỏ nền',
  'adsv2.build.sections.backgroundImage': 'Ảnh…',
  'adsv2.build.sections.backgroundImageHint': 'Chọn ảnh PNG/JPEG/WebP làm nền. Ảnh được ghép vào khung và nén WebP (2× khung) để nhẹ.',
  'adsv2.build.sections.backgroundUseColor': 'Dùng màu',
  'adsv2.build.sections.backgroundFit': 'Cách đặt ảnh vào khung',
  'adsv2.build.sections.backgroundFit.cover': 'Phủ kín (cắt mép)',
  'adsv2.build.sections.backgroundFit.contain': 'Vừa khung (chừa viền)',
  'adsv2.build.sections.backgroundFit.stretch': 'Kéo giãn',
  'adsv2.build.sections.backgroundImageFailed': 'Không đọc được ảnh, hoặc ảnh quá nặng sau khi nén.',
  'adsv2.build.sections.advance': 'Chuyển màn',
  'playable.editor.transition.label': 'Hiệu ứng chuyển màn',
  'playable.editor.transition.none': 'Không (chuyển ngay)',
  'playable.editor.transition.type.flash': 'Chớp trắng',
  'playable.editor.transition.type.fade': 'Mờ dần',
  'playable.editor.transition.type.slide-left': 'Trượt sang trái',
  'playable.editor.transition.type.slide-right': 'Trượt sang phải',
  'playable.editor.transition.type.slide-up': 'Trượt lên',
  'playable.editor.transition.type.slide-down': 'Trượt xuống',
  'playable.editor.transition.type.zoom': 'Phóng to',
  'playable.editor.transition.seconds': 'Kéo dài (giây):',
  'playable.editor.transition.hint': 'tối đa {n}s, tính thêm vào thời gian của màn',
  'adsv2.icons.title': 'Kho icon',
  'adsv2.icons.search': 'Tìm icon (play, star, tim, cup…)',
  'adsv2.icons.color': 'Màu',
  'adsv2.icons.stroke': 'Nét',
  'adsv2.icons.empty': 'Không có icon nào khớp.',
  'adsv2.icons.failed': 'Không tạo được ảnh icon — thử lại hoặc chọn icon khác.',
  'adsv2.icons.loading': 'Đang mở kho icon…',
  'adsv2.icons.group.action': 'Thao tác',
  'adsv2.icons.group.gesture': 'Cử chỉ',
  'adsv2.icons.group.game': 'Trò chơi',
  'adsv2.icons.group.emotion': 'Cảm xúc',
  'adsv2.icons.group.shop': 'Mua sắm & số liệu',
  'adsv2.icons.group.media': 'Media & thiết bị',
  'adsv2.icons.group.social': 'Giao tiếp',
  'adsv2.icons.group.nature': 'Đời sống & thiên nhiên',
  'adsv2.icons.group.time': 'Thời gian & khác',
  'adsv2.build.sections.addIcon': 'Icon',
  'adsv2.build.zoom.out': 'Thu nhỏ',
  'adsv2.build.zoom.in': 'Phóng to',
  'adsv2.build.zoom.slider': 'Mức phóng to canvas (100%–1000%)',
  'adsv2.build.zoom.reset': 'Về 100%',
  'adsv2.build.zoom.hint': 'Phóng to canvas từ 100% đến 1000%. Giữ Ctrl (⌘) và cuộn chuột để zoom tại con trỏ; cuộn hoặc kéo thanh cuộn để di chuyển khi đã phóng to.',
  'adsv2.build.sections.elements': 'Thành phần',
  'adsv2.build.sections.showAll': '← Hiện lại các mục (bỏ chọn)',
  'adsv2.build.sections.import': 'Import',
  'playable.editor.import.useAsBackground': 'Đặt ảnh chụp làm nền, các thành phần dựng đè lên (bỏ chọn nếu chỉ muốn khung)',
  'playable.editor.import.letterboxed': 'Tỉ lệ ảnh khác khung quảng cáo — đã thu vừa, hai bên để trống.',
  'playable.editor.import.backgroundSkipped': 'Không đặt được ảnh làm nền (ảnh quá nặng sau khi thu).',
  'playable.editor.import.sizeDiffers': 'HTML này dựng cho khung {size}; các thành phần đã được kẹp vào khung hiện tại.',
  'playable.editor.import.pickFile': 'Chọn file (ảnh hoặc .html)…',
  'playable.editor.import.fromFile': 'Dựng từ file',
  'playable.editor.import.working': 'Đang đọc…',
  'playable.editor.import.tooLarge': 'Ảnh quá nặng (tối đa 6MB).',
  'playable.editor.import.nothing': 'AI không nhận ra thành phần nào trong nguồn này.',
  'playable.editor.import.done': 'Đã dựng {n} thành phần.',
  'adsv2.build.sections.advanceLocked': 'Màn khóa — cách chuyển màn không sửa được ở đây.',
  'adsv2.build.sections.addElement': 'Thêm phần tử',
  'adsv2.build.slot.image.none': '— không có ảnh —',
  'adsv2.build.slot.image.pick': 'Chọn ảnh có sẵn',
  'adsv2.build.slot.image.upload': 'Tải ảnh lên',
  'adsv2.build.slot.image.totalTooLarge': 'Template đã hết dung lượng cho ảnh (tối đa 6 MB tổng).',
  'adsv2.build.slot.kind.text': 'Chữ',
  'adsv2.build.slot.kind.image': 'Ảnh',
  'adsv2.build.slot.kind.button': 'Nút',
  'adsv2.build.slot.kind.box': 'Hộp',
  'adsv2.build.slot.kind.line': 'Đường kẻ',
  'adsv2.build.slot.kind.progress': 'Tiến trình',
  'adsv2.build.slot.locked.noModel': 'Màn thư viện không có bản canvas — thêm lại từ thư viện để sửa.',
  'adsv2.locked.title': 'Trang này dành cho nhóm Marketing / UA',
  'adsv2.locked.body': 'Tài khoản của bạn chưa có quyền xem báo cáo Marketing / UA nên chưa dùng được trình dựng này. Liên hệ admin nếu cần.',
  'adsv2.build.previewSkipped': 'Màn {n} ({name}) không hiện trong preview nhưng VẪN được lưu',
  'adsv2.export.emptyRender': 'Không nhận được ảnh cho {size} — thử lại kích thước đó.',
  'adsv2.export.downloadAll': 'Tải tất cả',
  'adsv2.export.downloadAllCounts': 'Tải tất cả — HTML ×{h} · Ảnh ×{i} · Video ×{v}',
  'adsv2.export.downloadAllHint': 'Một file ZIP duy nhất gồm 3 thư mục HTML/, IMG/, MP4/ — mỗi thư mục dựng theo đúng tuỳ chọn đang đặt ở tab đó (kích thước, khớp khung, thời điểm chụp ảnh…) cho các bản đã tích. Đổi tab không mất tuỳ chọn đã chọn.',
  'adsv2.export.downloadAllNothing': 'Không tạo được file nào — kiểm tra lại các bản đã tích và tuỳ chọn từng tab.',
  'adsv2.export.allStage.HTML': 'Đang dựng HTML…',
  'adsv2.export.allStage.IMG': 'Đang dựng ảnh…',
  'adsv2.export.allStage.MP4': 'Đang dựng video…',
  'playable.editor.advance.tapAutoAdvance': 'Tự chuyển màn nếu không nhấn',
  'playable.editor.advance.tapTimerElsewhere': 'Hết "Thời gian tối đa" ở mục General design thì màn tự chuyển.',
  'adsv2.build.sections.maxTimeTapOff': 'Màn này chờ nhấn và không tự chuyển. Tick "Tự chuyển màn nếu không nhấn" ở mục Chuyển màn để đặt thời gian.',
  'adsv2.build.sections.advanceLockedTap': 'Màn khóa: hẹn giờ của màn nhấn được đặt hoặc xóa ở timeline (ô giây và nút ×), không phải ở đây.',
  'playable.editor.align.front': 'Lên trên cùng',
  'playable.editor.align.frontHint': 'Đưa phần tử lên trên mọi phần tử cùng cấp (Alt+Shift+↑).',
  'playable.editor.align.forward': 'Lên 1 lớp',
  'playable.editor.align.forwardHint': 'Đưa phần tử lên một lớp (Alt+↑).',
  'playable.editor.align.backward': 'Xuống 1 lớp',
  'playable.editor.align.backwardHint': 'Đưa phần tử xuống một lớp (Alt+↓).',
  'playable.editor.align.back': 'Xuống dưới cùng',
  'playable.editor.align.backHint': 'Đưa phần tử xuống dưới mọi phần tử cùng cấp (Alt+Shift+↓).',
  'adsv2.build.sections.foldGroup': 'Thu gọn nhóm: ẩn các phần tử của nhóm trong danh sách',
  'adsv2.build.sections.unfoldGroup': 'Mở nhóm: hiện các phần tử của nhóm trong danh sách',
  'adsv2.build.imageZoom.label': 'Phóng to ảnh',
  'adsv2.build.imageZoom.hint': 'Phóng to ảnh bên trong khung: 100% hiện cả ảnh, lớn hơn thì cắt vào. Khung không đổi.',
  'adsv2.build.imageZoom.anchor': 'Giữ phần',
  'adsv2.build.imageZoom.anchorOff': '(phóng to trước)',
  'adsv2.build.imageZoom.anchorAt': 'Giữ phần {y} {x} của ảnh trong khung',
  'adsv2.build.imageZoom.x0': 'trái',
  'adsv2.build.imageZoom.x50': 'giữa',
  'adsv2.build.imageZoom.x100': 'phải',
  'adsv2.build.imageZoom.y0': 'trên',
  'adsv2.build.imageZoom.y50': 'giữa',
  'adsv2.build.imageZoom.y100': 'dưới',
  'playable.editor.fx.title': 'Hiệu ứng lớp',
  'playable.editor.fx.add': 'Thêm hiệu ứng',
  'playable.editor.fx.remove': 'Xóa hiệu ứng',
  'playable.editor.fx.dropShadow': 'Đổ bóng',
  'playable.editor.fx.innerShadow': 'Bóng trong',
  'playable.editor.fx.layerBlur': 'Làm mờ lớp',
  'playable.editor.fx.backgroundBlur': 'Làm mờ nền phía sau',
  'playable.editor.fx.blur': 'Mờ',
  'playable.editor.fx.spread': 'Lan',
  'playable.editor.fx.opacity': 'Độ đậm',
  'playable.editor.effect.cascade': 'Áp dụng cho mọi phần tử trong nhóm',
  'playable.editor.effect.cascadeHint': 'Mọi phần tử trong nhóm cũng chạy chuyển động này, cùng với chuyển động riêng của nó (nếu có). Chỉ chuyển động của cả phần tử mới áp được (không áp dụng cho chữ chạy từng ký tự, thanh quét hay thanh tiến trình).',
}
